import EventEmitter from 'events'
import * as firebase from "firebase";
import firebaseApp from  "./FirebaseApp";

// extend EventEmitter so user of CardRepository can react to our own defined events (ex: CardRepository.on('added'))
class cardRepository extends EventEmitter {
	constructor () {
	    super()

		this.ref = firebase.database().ref('cards')
    this.userRef = firebase.database().ref('users')
    this.stackRef = firebase.database().ref('stacks')

  }

  	create ({
        type, 
        title, 
        author, 
        description, 
        url, image, 
        snippet='', 
        icon, 
        show, 
        source, 
        creator, 
        stack, 
        order, 
        stackCount,
        length,
        boundStack
        }, onComplete) {
        var that = this
  	    this.ref.push({type, title, author, description, url, image, snippet, icon, show, source, creator, length, boundStack}, onComplete).then(function(card){
          //add timestamp
          that.ref.child(card.key).update({created: firebase.database.ServerValue.TIMESTAMP}, onComplete)

          //add card key to user
          that.userRef.child(creator + '/cards/' + card.key).set(true, onComplete)

          // Increment user card count by 1.
          that.userRef.child(creator + '/cardCount').transaction(function(currentCount) {
            return currentCount + 1;
          });
          
          if(stack){
            that.addStack(card,stack,order)
          }

          //if this card is created for a twin stack
          if(boundStack) {
            that.stackRef.child(boundStack + '/boundCard').set(card.key, onComplete)
          }
        })
  	}

  	update ({key, title = '', description = '', url ='', image='', source='', snippet='', show}, onComplete) {
          this.ref.child(key).update({title, description, url, image, source, snippet, show}, onComplete)
  	     // key is used to find the child, a new note object is made without the key, to prevent key being inserted in Firebase
  	    // this.ref.child(key) will create new reference like this new Firebase(`https://<YOUR-FIREBASE-APP>.firebaseio.com/notes/${key}`)
  	}

  	// removes a note
  	remove (card, onComplete) {

      var that = this 

      //if card possess parent stacks, delete card from those stacks
      if(card.stacks) {
        var stackKeys = card.stacks
        for(var stackKey in stackKeys) {

          //for every stack, call removeStack
          this.stackRef.child(stackKey).once("value",function(snapshot){
            let stack = snapshot.val()
            stack.key = snapshot.key
            that.removeStack(card, stack)
          })
        }
      }

      //delete card from firebase
  	  this.ref.child(card.key).remove(onComplete)

      //delete card reference from creator
      this.userRef.child(card.creator + '/cards/' + card.key).remove(onComplete)

      // decrease user card count by 1.
      this.userRef.child(card.creator + '/cardCount').transaction(function(currentCount) {
        return currentCount - 1;
      });
      
  	}

  addStack(card, stack, order, onComplete) {

    //add card key to stack and update card count
    this.stackRef.child(stack.key + '/cards/' + card.key).set(true, onComplete)
    this.stackRef.child(stack.key + '/cards/' + card.key).set({order: order}, onComplete)
    this.stackRef.child(stack.key + '/cardCount').transaction(function(currentCount) {
      return currentCount + 1;
    })

    //add stack key to card and update stack count
    this.ref.child(card.key + '/stacks/' + stack.key).set(true, onComplete)
    this.ref.child(card.key + '/stackCount').transaction(function(currentCount) {
      return currentCount + 1;
    })

    //update stack's bound card
    this.ref.child(stack.boundCard + '/length').transaction(function(currentCount) {
      return currentCount + 1;
    })
  }

  removeStack({key}, stack, onComplete) {
    var that = this

    var stackUpdatedCount

    var stackToRemoveRef = this.stackRef.child(stack.key)

    var cardToRemoveOrder


    //remove stack key from card
    this.ref.child(key + '/stacks/' + stack.key).remove(onComplete)

    //decrease stack count from card
    this.ref.child(key + '/stackCount').transaction(function(currentCount) {
      return currentCount - 1;
    })


    //get removed card's order number
    stackToRemoveRef.child('/cards/' + key + '/order/').once("value", function(snapshot){

      cardToRemoveOrder = snapshot.val()

      //remove card key from stack
      stackToRemoveRef.child('/cards/' + key).remove(onComplete).then(function(){

        //after removing, count remaining stacks and update accordingly
        stackToRemoveRef.child('/cards/').once("value",function(snapshot){

          if(snapshot.val()) {

            var remainingStacks = snapshot.val()
            stackUpdatedCount = Object.keys(remainingStacks).length

            //update card count from stack
            stackToRemoveRef.child('/cardCount').set(stackUpdatedCount, onComplete)

            //update stack's bound card length/count
            that.ref.child(stack.boundCard + '/length').set(stackUpdatedCount, onComplete)

            //for each snapshot object, decrement order by 1 if it has an order number higher than removed card
            snapshot.forEach(function(remainingStack) {
              //get order object
              let stack = remainingStack.val()
              let key = remainingStack.key

              if(stack.order > cardToRemoveOrder) {
                stackToRemoveRef.child('/cards/' + key + '/order/').set(stack.order - 1, onComplete) 
              }

            });

          } else {
            //update card count from stack
            stackToRemoveRef.child('/cardCount').set(0, onComplete)

            //update stack's bound card length/count
            that.ref.child(stack.boundCard + '/length').set(0, onComplete)
          }  
        })
      })
    })
  }

  removeStackfromCards({key}, cardkeys, onComplete){

    for (var cardkey of cardkeys){
      this.ref.child(cardkey + '/stacks/' + key).remove(onComplete)
    }
  }

	attachFirebaseListeners () {
	    this.ref.on('child_added', this.onAdded, this)
	    this.ref.on('child_removed', this.onRemoved, this)
	    this.ref.on('child_changed', this.onChanged, this)
  	}

  	// dettach listeners from Firebase
  	detachFirebaseListeners () {
  	    this.ref.off('child_added', this.onAdded, this)
  	    this.ref.off('child_removed', this.onRemoved, this)
  	    this.ref.off('child_changed', this.onChanged, this)
        this.stackRef.off()
        this.userRef.off()
  	}

	onAdded (snapshot) {
      // process data
      let card = this.snapshotToCard(snapshot)
      // propagate event outwards with note
      this.emit('added', card)
   }

   onRemoved (oldSnapshot) {
     let card = this.snapshotToCard(oldSnapshot)
     this.emit('removed', card)
   }

   onChanged (snapshot) {
     let card = this.snapshotToCard(snapshot)
     this.emit('changed', card)
   }

   snapshotToCard (snapshot) {
       // we will need the key often, so we always want to have the key included in the note
       let key = snapshot.key
       let card = snapshot.val()
       card.key = key
       card.username = null  

       this.userRef.child(card.creator + '/username').on('value', function(snapshot) {
         card.username = snapshot.val()
       })

       return card
     }

    // Finds the index of the note inside the array by looking for its key
    findIndex (cards, key) {
       return cards.findIndex(card => card.key === key)
    }

    // Finds the note inside the array by looking for its key
    find (cards, key) {
        return cards.find(card => card.key === key)
    }
}
export default new cardRepository() // this instance will be shared across imports


// WEBPACK FOOTER //
// ./src/data/CardRepository.js